<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
========================================================================================== -->
<template src="./login.html" />

<script>
import mixins from "@/mixins/mixins.js";
import { ToolIcon } from "vue-feather-icons";
export default {
  components: {
    ToolIcon,
  },
  mixins: [mixins],
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: true,
      bearer_code: "1",
      invalidPassword: false,
      nonexistentUser : false,
      passwordType: "password",
      invalidLogin: false,
      invalidPasswordField: false,
      textDangerLogin: "",
      textDangerPassword: "",
    };
  },
  mounted: function() {
    this.$vs.loading.close();
    if (this.$cookies.get("user") !== null) {
      this.email = this.$cookies.get("user").userName;
      this.password = this.$cookies.get("user").password;
    }
  },
  methods: {
    renewPassword() {
      this.axios
        .post(this.$store.state.filooServer + "users/forgot-password", {
          email: this.email,
          type: "COMPANY",
        })
        .then(() => {
          this.$bvModal.hide("modal-login-forgot-password");
          this.$bvModal.show("modal-login-forgot-password-success");
        })
        .catch(() => {
          this.$bvModal.hide("modal-login-forgot-password");
          this.$bvModal.show("modal-login-forgot-password-error");
        });
    },
    validatingMandatoryFields(){
      let validFields = true;
      if(this.testNullUndefinedEmpty(this.email)){
        this.invalidLogin = true;
        this.textDangerLogin = "Campo obrigatório";
        validFields = false;
      }
      if(this.testNullUndefinedEmpty(this.password)){
        this.invalidPasswordField = true;
        this.textDangerPassword = "Campo obrigatório";
        validFields = false;
      }
      if (validFields) {
        this.login();
      } else {
        return;
      }
    },
    login() {
      this.axios
        .post(this.$store.state.filooServer + "company/login", {
          username: this.email,
          password: this.password,
        })
        .then(({ status, headers }) => {
          if (status === 200) {
            this.$session.start();
            this.$session.set("bearer", headers.authorization);
            this.$session.set("bearerDefault", headers.authorization);
            this.bearer_code = headers.authorization;
            var user = {
              userName: this.email,
              password: this.password,
            };
            if (this.checkbox_remember_me) {
              this.$cookies.set("user", user);
            } else {
              this.$cookies.remove("user");
            }
            this.getMe();
          }
        })
        .catch((error) => {
          this.invalidPasswordField = true;
          this.invalidLogin = true;
          this.textDangerLogin = "";
          this.textDangerPassword = "";
          if (error.status === 401) {
            this.invalidPassword = true;
          } else {
            if (error.response.data.message == "Usuário não cadastrado") {
              this.nonexistentUser = true;
            }
            if (error.response.data.message == "Usuário ou senha inválido") {
              this.invalidPassword = true;
            }
          }
        });
    },

    getMe() {
      this.axios
        .get(this.$store.state.filooServer + "me", {
          headers: {
            Authorization: this.bearer_code,
          },
        })
        .then(({ data }) => {
          this.$session.set("customer", data)
          this.getInfoCompany();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInfoCompany() {
      this.axios
        .get(this.$store.state.filooServer + "company", {
          headers: {
            Authorization: this.$session.get("bearer"),
          },
        })
        .then(({ status, data }) => {
          if (status === 200) {
            this.$session.set("name", data.name);
            this.$session.set("idCompany", data.id);
            this.$session.set("company", data);
            this.$router.push("/company-dashboard");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    
    passwordVisibility() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
  },
};
</script>

<style lang="scss" src="./login.scss" />
